import { render, staticRenderFns } from "./notice-formula-list.html?vue&type=template&id=78efb73a&scoped=true&external"
import script from "./notice-formula-list.js?vue&type=script&lang=js&external"
export * from "./notice-formula-list.js?vue&type=script&lang=js&external"
import style0 from "./notice-formula-list.scss?vue&type=style&index=0&id=78efb73a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78efb73a",
  null
  
)

export default component.exports